import * as React from 'react';

import GatsbyImage from 'gatsby-image';
import { useStaticQuery, graphql } from 'gatsby';
import { useGraphQL } from '../hooks';

function FAQ() {
  const { heroFAQ } = useStaticQuery(graphql`
    {
      heroFAQ: file(relativePath: { eq: "faq/faq-hero.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1280) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);

  const {
    site: { siteMetadata },
  } = useGraphQL();
  return (
    <article className="w-full px-6 mx-auto mb-24 max-w-7xl md:px-0">
      <GatsbyImage
        fluid={heroFAQ.childImageSharp.fluid}
        className="relative mb-16 max-h-96"
      />
      <div className="w-full max-w-2xl mx-auto">
        <h1 className="h2">Frequently Asked Questions</h1>
        <div className="mt-6 prose">
          <dl>
            <div className="pt-4 first:pt-0">
              <dt>
                <span aria-label="Question">Q. </span>How do I speak to someone?
              </dt>
              <dd>
                <p>
                  <span aria-label="Answer" className="font-bold text-gray-900">
                    A.{' '}
                  </span>
                  Phone {siteMetadata.phone[0].name} on{' '}
                  <a href={`tel:${siteMetadata.phone[0].numberFormatted}`}>
                    {siteMetadata.phone[0].numberDisplay}
                  </a>{' '}
                  or {siteMetadata.phone[1].name}{' '}
                  <a href={`tel:${siteMetadata.phone[1].numberFormatted}`}>
                    {siteMetadata.phone[1].numberDisplay}
                  </a>
                  . If we are unavailable we promise to contact you as soon as
                  possible. If you are speaking on our Mailbox please speak
                  slowly and precisely when leaving a contact number.
                </p>
              </dd>
            </div>
            <div className="pt-4 first:pt-0">
              <dt>
                <span aria-label="Question">Q. </span>Do you offer discounts for
                teams?
              </dt>
              <dd>
                <p>
                  <span aria-label="Answer" className="font-bold text-gray-900">
                    A.{' '}
                  </span>
                  Yes, we offer discounts for teams. Send us an email (
                  <a href={`mailto:${siteMetadata.email}`}>
                    {siteMetadata.email}
                  </a>
                  ) or phone directly to discuss your individual wishes and
                  needs.
                </p>
              </dd>
            </div>
            <div className="pt-4 first:pt-0">
              <dt>
                <span aria-label="Question">Q. </span>Do you ship
                internationally?
              </dt>
              <dd>
                <p>
                  <span aria-label="Answer" className="font-bold text-gray-900">
                    A.{' '}
                  </span>
                  Yes we do. We have delivery prices for all countries which
                  will be calculated at checkout depending on weight and size.
                </p>
              </dd>
            </div>
            <div className="pt-4 first:pt-0">
              <dt>
                <span aria-label="Question">Q. </span>What are your shipping
                costs and delivery times?
              </dt>
              <dd>
                <ul className="pl-5">
                  <li className="-ml-5 list-none">
                    <span
                      aria-label="Answer"
                      className="font-bold text-gray-900"
                    >
                      A.{' '}
                    </span>
                    <span className="font-bold text-gray-900">Australia: </span>
                    Free delivery on all orders over $100.00. All other orders
                    will have a standard rate of $8.00.
                  </li>
                  <li className="-ml-5 list-none">
                    <span
                      aria-label="Answer"
                      className="font-bold text-gray-900"
                    >
                      B.{' '}
                    </span>
                    <span className="font-bold text-gray-900">
                      Rest of the world:{' '}
                    </span>
                    Delivery prices will be calculated at checkout depending on
                    weight and size.
                  </li>
                  <li>All orders will be processed with 24 hours.</li>
                  <li>
                    Saturday, Sunday and State Holidays do not count as shipping
                    days.
                  </li>
                </ul>
              </dd>
            </div>
            <div className="pt-4 first:pt-0">
              <dt>
                <span aria-label="Question">Q. </span>What is your Returns
                Policy?
              </dt>
              <dd>
                <ul className="pl-5">
                  <li className="-ml-5 list-none">
                    <span
                      aria-label="Answer"
                      className="font-bold text-gray-900"
                    >
                      A.{' '}
                    </span>
                    Item(s) need to be returned within 14 days of purchase.
                  </li>
                  <li>
                    The item(s) is in resalable condition (i.e. the original
                    tags and labels are still attached, the item is in it's
                    original packaging (if any), and the item is unworn, unused
                    and as sold).
                  </li>
                  <li>The item is not a custom made product.</li>
                </ul>
              </dd>
            </div>
            <div className="pt-4 first:pt-0">
              <dt>
                <span aria-label="Question">Q. </span>What is the Returns
                Process?
              </dt>
              <dd>
                <p>
                  <span aria-label="Answer" className="font-bold text-gray-900">
                    A.{' '}
                  </span>
                  If you have changed your mind about your purchase or have
                  ordered the incorrect size/specifications, your item must be
                  freighted back to {siteMetadata.title} at your expense.
                </p>
                <p>
                  If your purchased item is defective or has been sent
                  incorrectly, we will organise a return pick-up at our expense.
                </p>
                <p>
                  Send an email to{' '}
                  <a href={`mailto:${siteMetadata.email}`}>
                    {siteMetadata.email}
                  </a>{' '}
                  stating the reason for the return and whether you would like a
                  refund, an exchange or a credit. We will then reply to your
                  return request with further instruction as soon as possible.
                </p>
                <p>Refund does not include original outgoing shipping cost.</p>
                <p>
                  {siteMetadata.title} reserve the right to charge an $8.00
                  administration charge in exceptional return circumstances.
                </p>
                <p>Clearance or Final Sale items may not be returned.</p>
                <p className="font-bold text-gray-900">Receiving a Refund</p>
                <p>
                  Your refund will either be credited to the original purchasers
                  credit card or PayPal account.
                </p>
                <p>
                  <span className="font-bold text-gray-900">Please note</span>{' '}
                  card refunds may take up to 5 business days for your bank to
                  complete, depending their processing time. This can vary
                  greatly between card issuers, and unfortunately we are unable
                  to influence this.
                </p>
              </dd>
            </div>

            <div className="pt-4 first:pt-0">
              <dt>
                <span aria-label="Question">Q. </span>Do you have a store
                location?
              </dt>
              <dd>
                <p>
                  <span aria-label="Answer" className="font-bold text-gray-900">
                    A.{' '}
                  </span>
                  Our retail showroom is located at {siteMetadata.address}. Call{' '}
                  {siteMetadata.phone[0].name} (
                  <a href={`tel:${siteMetadata.phone[0].numberFormatted}`}>
                    {siteMetadata.phone[0].numberDisplay}
                  </a>
                  ), {siteMetadata.phone[1].name} (
                  <a href={`tel:${siteMetadata.phone[1].numberFormatted}`}>
                    {siteMetadata.phone[1].numberDisplay}
                  </a>
                  ) or just pop in!
                </p>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </article>
  );
}

export { FAQ };
